import React from 'react'
import { cn } from '~shared/utils/cn'

import { IconArrowRight } from './icons/IconArrowRight'
import Link from 'next/link'
import { getProgramData } from '~shared/api/single-program-data/single-program-data'

export const LicenseAndAccreditationSection = ({
  program
}: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const docs = [
    {
      id: 1,
      title: 'Государственная лицензия',
      img: ['kursy', 'mba'].includes(program?.category?.slug ?? '')
        ? '/assets/imgs/docs/license.jpg'
        : '/assets/imgs/docs/licenseHigh.jpg',
      link: 'https://islod.obrnadzor.gov.ru/rlic/details/0B100E0A-0A0B-110B-0D10-0E13110C0C111010110E/' as `http${string}`,
      linkCourse:
        'https://islod.obrnadzor.gov.ru/rlic/details/e6d90a44-2d1c-3f1e-38cd-23b05043cdb7/' as `http${string}`,
      bg: 'url(/assets/imgs/eagle.png) no-repeat bottom center #FFFFFF99'
    },
    {
      id: 2,
      title: 'Государственная аккредитация',
      img: '/assets/imgs/docs/accreditation.jpg',
      link: '/assets/docs/Аккредитация МИТМ.pdf' as `/${string}`,
      bg: 'url(/assets/imgs/eagle.png) no-repeat bottom center #2969E31A'
    }
  ]
  return (
    <>
      <section className='bg-[#F2F2F2] py-[80px] text-black'>
        <div
          className={cn(
            'mx-auto px-[16px] box-border',
            'max-w-[672px]',
            'md:max-w-[832px]',
            '2lg:max-w-[1280px]'
          )}>
          <h2
            className={cn(
              'mb-[24px] text-[32px] font-medium',
              'md:text-[48px] md:mb-[32px]',
              '2lg:mb-[56px] 2lg:text-[64px]'
            )}>
            Официальные документы
          </h2>
          <div className='2lg:grid grid-cols-2 gap-[32px]'>
            {docs.map(({ id, title, img, link, linkCourse, bg }) => (
              <div
                style={{ background: bg }}
                key={id}
                className={cn(
                  'mb-[24px] p-[24px] rounded-[16px] md:h-[348px] md:flex justify-between',
                  'bg-cover',
                  bg
                )}>
                <div className='flex md:flex-col justify-between mb-[24px] md:mb-0'>
                  <h3 className='text-[20px] md:text-[24px] font-medium max-w-[300px]'>
                    {title}
                  </h3>
                  <Link
                    href={`${id === 1 ? (['kursy', 'mba'].includes(program?.category?.slug ?? '') ? linkCourse : link) : link}`}
                    target='_blank'
                    className={cn(
                      'h-[40px] w-[40px] rounded-full flex items-center justify-center bg-accent hover:bg-black transition-colors',
                      'md:w-[68px] md:h-[68px]'
                    )}>
                    <IconArrowRight />
                  </Link>
                </div>
                <img
                  src={img}
                  alt={title}
                  className='h-full w-fit rounded-[16px]'
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
